// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G0cnN","label":"styles_label__3YR5s"};